import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { usePermissao } from '../hooks/usePermissao';

const cor = '#B51013';

const PASSOS = [
  {
    id: 'cursos',
    icone: '📚',
    titulo: 'Cadastre os cursos',
    desc: 'Adicione os treinamentos da empresa na Biblioteca de cursos.',
    rota: '/biblioteca',
    acao: 'gerenciarCursos',
  },
  {
    id: 'mascaras',
    icone: '🎯',
    titulo: 'Configure as máscaras',
    desc: 'Defina quais treinamentos são obrigatórios para cada função.',
    rota: '/mascaras',
    acao: 'gerenciarMascaras',
  },
  {
    id: 'colaboradores',
    icone: '👥',
    titulo: 'Cadastre os colaboradores',
    desc: 'Adicione os funcionários individualmente ou via importação CSV.',
    rota: '/colaboradores',
    acao: 'cadastrarColaborador',
  },
];

export default function GuiaPrimeiroAcesso() {
  const { pode } = usePermissao();
  const navigate = useNavigate();
  const [estado, setEstado] = useState(null);
  const [fechado, setFechado] = useState(() => localStorage.getItem('guia_fechado') === '1');

  useEffect(() => {
    if (fechado || !pode('cadastrarColaborador')) return;
    verificar();
  }, []);

  const verificar = async () => {
    try {
      const [colabSnap, cursoSnap] = await Promise.all([
        getDocs(query(collection(db, 'colaboradores'), limit(1))),
        getDocs(query(collection(db, 'cursos'), limit(1))),
      ]);
      const semColab = colabSnap.empty;
      const semCursos = cursoSnap.empty;
      if (semColab || semCursos) setEstado({ semColab, semCursos });
    } catch {}
  };

  const fechar = () => {
    localStorage.setItem('guia_fechado', '1');
    setFechado(true);
  };

  if (fechado || !estado) return null;

  const passosVisiveis = PASSOS.filter(p => {
    if (p.id === 'cursos' && estado.semCursos) return true;
    if (p.id === 'colaboradores' && estado.semColab) return true;
    if (p.id === 'mascaras') return true;
    return false;
  }).filter(p => pode(p.acao));

  if (passosVisiveis.length === 0) return null;

  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: `2px solid ${cor}20`, padding: '20px', marginBottom: '20px', position: 'relative' }}>
      <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
        <span onClick={fechar} style={{ cursor: 'pointer', color: '#aaa', fontSize: '16px' }}>✕</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
        <span style={{ fontSize: '24px' }}>🚀</span>
        <div>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a1a' }}>Bem-vindo ao Jatear LMS!</div>
          <div style={{ fontSize: '12px', color: '#888' }}>Complete os passos abaixo para começar a usar o sistema.</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${passosVisiveis.length}, minmax(0,1fr))`, gap: '10px' }}>
        {passosVisiveis.map((p, i) => (
          <div key={p.id} onClick={() => navigate(p.rota)} style={{ background: '#f9f9f9', borderRadius: '10px', padding: '14px', cursor: 'pointer', border: '1px solid #f0f0f0', transition: 'border-color 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = cor}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#f0f0f0'}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
              <span style={{ width: '22px', height: '22px', borderRadius: '50%', background: cor, color: '#fff', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</span>
              <span style={{ fontSize: '14px' }}>{p.icone}</span>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#1a1a1a' }}>{p.titulo}</span>
            </div>
            <p style={{ margin: 0, fontSize: '11px', color: '#888', lineHeight: '1.5' }}>{p.desc}</p>
            <div style={{ marginTop: '8px', fontSize: '11px', color: cor, fontWeight: '600' }}>Ir agora →</div>
          </div>
        ))}
      </div>
    </div>
  );
}
